import React, {useEffect, useId, useRef} from 'react';
import {createPortal} from 'react-dom';
import './AccountTheme.css';

export default function AccountConfirmationDialog({title, description, cancelLabel, confirmLabel, busyLabel, busy, onCancel, onConfirm}) {
    const id = useId();
    const dialog = useRef(null);
    const cancel = useRef(onCancel);
    const pending = useRef(busy);
    cancel.current = onCancel;
    pending.current = busy;

    useEffect(() => {
        const trigger = document.activeElement;
        const overflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        dialog.current.querySelector('button').focus();
        const keydown = event => {
            if (event.key === 'Escape') {
                event.preventDefault();
                if (!pending.current) cancel.current();
            }
            if (event.key === 'Tab') {
                const buttons = dialog.current.querySelectorAll('button:not(:disabled)');
                const first = buttons[0];
                const last = buttons[buttons.length - 1];
                if (!first) {
                    event.preventDefault();
                    dialog.current.focus();
                } else if (event.shiftKey && (document.activeElement === first || !dialog.current.contains(document.activeElement))) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && (document.activeElement === last || !dialog.current.contains(document.activeElement))) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        document.addEventListener('keydown', keydown);
        return () => {
            document.body.style.overflow = overflow;
            document.removeEventListener('keydown', keydown);
            if (trigger?.isConnected) trigger.focus();
        };
    }, []);

    return createPortal(<div className="nw-account nw-account-confirm" onClick={event => {if (event.target === event.currentTarget && !busy) onCancel();}}>
        <section ref={dialog} className="nw-account-confirm__dialog" role="dialog" aria-modal="true" aria-labelledby={`${id}-title`} aria-describedby={`${id}-description`} aria-busy={busy} tabIndex={-1}>
            <h2 id={`${id}-title`}>{title}</h2>
            <p id={`${id}-description`}>{description}</p>
            <div className="nw-account-confirm__actions">
                <button type="button" className="nw-account__button nw-account__button--secondary" onClick={onCancel} disabled={busy}>{cancelLabel}</button>
                <button type="button" className="nw-account__button" onClick={onConfirm} disabled={busy}>{busy ? busyLabel : confirmLabel}</button>
            </div>
        </section>
    </div>, document.body);
}
